import React, { useEffect, useState } from "react";
import { AddButtonIconComponent } from "../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import { Modal, Row, Col } from "react-bootstrap";

import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";

function ChoosePreferenceModel(props) {
  const [show, setShow] = useState(false);
  const [state, setState] = useState(0);
  const [dates, setDates] = useState([]);
  useEffect(() => {
    let temp = [];
    for (let i = 0; i <= 30; i++) {
      temp.push(i + 1);
    }
    setDates(temp);
  }, []);
  return (
    <div>
      <AddButtonIconComponent
        buttonText="Choose Preference"
        onClick={() => setShow(true)}
        fontIcon="fa fa-plus"
        colorCss="blue"
      />
      <Modal show={show} size="md" onHide={() => setShow(false)} centered>
        <Modal.Header closeButton>
          <div className="row w-100">
            <div className="col-6 f12-500" style={{ color: "#2196F3" }}>
              Reset
            </div>
            <div className="col-4 f12-500">Preference</div>
          </div>
        </Modal.Header>
        <Modal.Body className="pt-0 pb-0">
          <Row>
            <Col
              xs={6}
              className="pr-0 pl-0"
              style={{ backgroundColor: "#F5F5F5" }}
            >
              <div>
                {[
                  "Date of Birth",
                  "Gender",
                  "Allergies",
                  "Age",
                  "Dietary Preferences",
                  "Cuisines",
                  "Country",
                  "City",
                ].map((data, index) => (
                  <div
                    className={`p-3 ${index === state ? "f12-700" : "f12-400"}`}
                    style={{
                      backgroundColor: index === state ? "#fff" : "",
                      cursor: index === state ? "" : "pointer",
                    }}
                    onClick={() => {
                      setState(index);
                    }}
                  >
                    {data}
                  </div>
                ))}
              </div>
            </Col>
            <Col xs={6}>
              {state === 0 && (
                <div>
                  <div className="mt-4">
                    <div className="f14-500">Select Month</div>
                    <div className="pl-3">
                      {[
                        "January",
                        "February",
                        "March",
                        "April",
                        "May",
                        "June",
                        "July",
                        "August",
                        "September",
                        "October",
                        "November",
                        "December",
                      ].map((data, index) => (
                        <div
                          key={index}
                          className="d-flex align-items-center mt-2"
                        >
                          <input type="checkbox" />
                          <div className="ml-3">{data}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="mt-4">
                    <div className="f14-500">Select Date</div>

                    <div className="pl-3">
                      {dates.map((data, index) => (
                        <div
                          key={index}
                          className="d-flex align-items-center mt-2"
                        >
                          <input type="checkbox" />
                          <div className="ml-3">{data}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}
              {state === 1 && (
                <div>
                  <div className="mt-4">
                    <div className="f14-500">Gender</div>
                    <div className="pl-3">
                      {["Male", "Female", "Others"].map((data, index) => (
                        <div
                          key={index}
                          className="d-flex align-items-center mt-2"
                        >
                          <input type="checkbox" />
                          <div className="ml-3">{data}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}

              {state === 2 && (
                <div>
                  <div className="mt-4">
                    <div className="f14-500">Allergies</div>
                    <div className="pl-3">
                      {[
                        "Milk",
                        "Soy",
                        "Gluten",
                        "Nuts",
                        "Seafood",
                        "Egg",
                        "Sesame",
                        "Mushroom",
                      ].map((data, index) => (
                        <div
                          key={index}
                          className="d-flex align-items-center mt-2"
                        >
                          <input type="checkbox" />
                          <div className="ml-3">{data}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}
              {state === 3 && (
                <div>
                  <div className="mt-4">
                    <div className="f14-500">Age</div>
                    <div className="pl-3">
                      {["15 - 20", "21 - 30", "31- 40", "41 - 50", "51<"].map(
                        (data, index) => (
                          <div
                            key={index}
                            className="d-flex align-items-center mt-2"
                          >
                            <input type="checkbox" />
                            <div className="ml-3">{data}</div>
                          </div>
                        )
                      )}
                    </div>
                  </div>
                </div>
              )}
              {state === 4 && (
                <div>
                  <div className="mt-4">
                    <div className="f14-500">Dietary Preferences</div>
                    <div className="pl-3">
                      {[
                        "Low Carb",
                        "Protein Rich",
                        "Vegan",
                        "Lactose Free",
                        "Gluten Free",
                      ].map((data, index) => (
                        <div
                          key={index}
                          className="d-flex align-items-center mt-2"
                        >
                          <input type="checkbox" />
                          <div className="ml-3">{data}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}
              {state === 5 && (
                <div>
                  <div className="mt-4">
                    <div className="f14-500">Cuisine</div>
                    <div className="filter-button-search">
                      <Paper
                        component="form"
                        style={{ border: "1px solid #E0E0E0" }}
                      >
                        <IconButton
                          style={{ padding: "0" }}
                          type="submit"
                          aria-label="search"
                        >
                          <SearchIcon />
                        </IconButton>
                        <InputBase
                          placeholder="Search"
                          inputProps={{
                            "aria-label": "Search by Name or Phone Number",
                          }}
                          //   onChange={this.onSearchChange}
                          //   value={this.state.search}
                        />
                      </Paper>
                    </div>
                    <div className="pl-3">
                      {["Afghani", "African", "American"].map((data, index) => (
                        <div
                          key={index}
                          className="d-flex align-items-center mt-2"
                        >
                          <input type="checkbox" />
                          <div className="ml-3">{data}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}

              {state === 6 && (
                <div>
                  <div className="mt-4">
                    <div className="f14-500">Country</div>
                    <div className="pl-3">
                      {["India"].map((data, index) => (
                        <div
                          key={index}
                          className="d-flex align-items-center mt-2"
                        >
                          <input type="checkbox" />
                          <div className="ml-3">{data}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}
              {state === 7 && (
                <div>
                  <div className="mt-4">
                    <div className="f14-500">City</div>
                    <div className="pl-3">
                      {[
                        "Pune",
                        "Mumbai",
                        "Bangalore",
                        "Hydrabad",
                        "Gujrat",
                      ].map((data, index) => (
                        <div
                          key={index}
                          className="d-flex align-items-center mt-2"
                        >
                          <input type="checkbox" />
                          <div className="ml-3">{data}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-danger w-100">Save</button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default ChoosePreferenceModel;
